import * as XLSX from "xlsx";

const NUM = /^-?₹?\s?-?[\d,]+(\.\d+)?$/;
// clone table: keep line breaks as " / " so merged cells stay readable
const prep = (t) => {
  const c = t.cloneNode(true);
  c.querySelectorAll("br").forEach((b) => b.replaceWith("\u00a0/\u00a0"));
  c.querySelectorAll("td > div + div, th > div + div").forEach((d) => d.prepend("\u00a0/\u00a0"));
  c.querySelectorAll("td, th").forEach((x) => { x.textContent = x.textContent.replace(/[\s\u00a0]+/g, " ").trim(); });
  return c;
};
// turn "₹1,234.50" / "26" text cells into real numbers so Excel can sum and sort
const numify = (ws) => {
  Object.keys(ws).forEach((a) => {
    const c = ws[a];
    if (a[0] === "!" || !c || c.t !== "s") return;
    const v = String(c.v).trim();
    if (NUM.test(v) && !/^0\d/.test(v.replace(/[₹\s-]/g, ""))) { c.t = "n"; c.v = Number(v.replace(/[₹,\s]/g, "")); delete c.w; }
  });
  return ws;
};

const slug = (s) => (s || "document").replace(/[^A-Za-z0-9]+/g, "_").replace(/^_|_$/g, "");

// Export every <table> inside root: Excel = one sheet per table, CSV = tables stacked with titles.
// One workbook, one sheet per [data-sheet] section (all monthly registers in one file).
export const exportSheets = (root, { title, month, org }) => {
  const secs = [...root.querySelectorAll("[data-sheet]")];
  const wb = XLSX.utils.book_new();
  secs.forEach((sec) => {
    const tables = [...sec.querySelectorAll("table")];
    const header = [[sec.dataset.sheet], [`Establishment: ${org || "—"}`], [`Month: ${month}`], []];
    const ws = XLSX.utils.aoa_to_sheet(header);
    let row = header.length;
    tables.forEach((t) => {
      XLSX.utils.sheet_add_dom(ws, prep(t), { origin: row, raw: true });
      row = XLSX.utils.decode_range(ws["!ref"]).e.r + 2;
    });
    numify(ws);
    ws["!cols"] = [...Array(30)].map((_, c) => ({ wch: c === 1 ? 26 : 14 }));
    XLSX.utils.book_append_sheet(wb, ws, sec.dataset.sheet.slice(0, 31));
  });
  if (!secs.length) return false;
  XLSX.writeFile(wb, `${slug(title)}_${month}.xlsx`);
  return true;
};

export const exportTables = (root, { title, month, org, format }) => {
  const tables = [...root.querySelectorAll("table")].filter((t) => !t.closest(".no-print"));
  if (!tables.length) return false;
  const name = `${slug(title)}_${month}`;
  const header = [[title], [`Establishment: ${org || "—"}`], [`Month: ${month}`], []];
  if (format === "csv") {
    const parts = tables.map((t, i) => {
      const ws = XLSX.utils.table_to_sheet(prep(t), { raw: true });
      return (tables.length > 1 ? `Table ${i + 1}\n` : "") + XLSX.utils.sheet_to_csv(ws);
    });
    const csv = header.map((r) => r.join(",")).join("\n") + "\n" + parts.join("\n\n");
    const a = document.createElement("a");
    a.href = URL.createObjectURL(new Blob(["\ufeff" + csv], { type: "text/csv;charset=utf-8" }));
    a.download = `${name}.csv`; a.click();
    setTimeout(() => URL.revokeObjectURL(a.href), 1000);
    return true;
  }
  const wb = XLSX.utils.book_new();
  tables.forEach((t, i) => {
    const ws = XLSX.utils.aoa_to_sheet(header);
    XLSX.utils.sheet_add_dom(ws, prep(t), { origin: header.length, raw: true });
    numify(ws);
    ws["!cols"] = [...Array(30)].map((_, c) => ({ wch: c === 1 ? 26 : 14 }));
    XLSX.utils.book_append_sheet(wb, ws, tables.length > 1 ? `Table ${i + 1}` : slug(title).slice(0, 31));
  });
  XLSX.writeFile(wb, `${name}.xlsx`);
  return true;
};
